// test423
(423 && 0);
